// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__mJbFK","search":"Settings_search__1WeuU","filter":"Settings_filter__mUxjv"};